import { StatusBar } from "expo-status-bar";
import React from "react";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  FlatList,
} from "react-native";
import Text from "app/components/Text";
import chapterActions from "app/utils/chapterActions";
import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import storageActions from "app/utils/storageActions";
import { styleSheet, colors, sizes } from "app/utils/styleSheet";
import * as RootNavigation from "app/utils/RootNavigation.js";

import Value from "app/components/Value";
import Timeline from "app/components/Timeline";
import TimelineGraph from "app/components/TimelineGraph";
import TimelineEvent from "app/components/TimelineEvent";
import FilterBar from "app/components/FilterBar";

import ScratchPad from "app/components/ScratchPad";
import MomentList from "app/components/chapter/MomentList";
import BadgeRow from "app/components/chapter/BadgeRow";

import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons";

import { StyleContext } from "app/contexts/Style";

export default class Agenda extends React.Component {
  static contextType = StyleContext;
  constructor(props) {
    super(props);
    let range = 300;
    this.state = {
      slots: [],
      events: [],
      chapters: [],
      values: [],
      fetching: true,
      startAt: timeHelpers.dateTimeToDate(timeHelpers.daysFromNow(-range)),
      endAt: timeHelpers.dateTimeToDate(),
      range,
      page: 0,
      momentLists: [],
    };
  }

  async componentDidMount() {
    this.generateSlots();
    this.fetch();
  }

  generateSlots = async () => {
    let { events, startAt, endAt, range } = this.state;
    events = textHelpers.uniq(events, "event_id");
    events = textHelpers.oldestFirst(events, "timestamp");
    console.log("timeline events:", events);

    let lastEventDay = null;

    let slots = [];
    let start = 0;
    let end = range;
    for (let i = start; i <= end; i++) {
      let slotDate = timeHelpers.tomorrow(startAt, i);
      slotDate = timeHelpers.dateTimeToDate(slotDate);
      let dateEvents = events.filter((ev) => {
        // let evTs = ev.completed_at || ev.created_at;
        let evTs = ev.timestamp;
        let evDate = timeHelpers.dateTimeToDate(evTs);
        if (evDate == slotDate) {
          return true;
        } else {
          return false;
        }
      });
      if (!!dateEvents.length) {
        lastEventDay = slotDate;
      }
      slots.push({
        date: slotDate,
        events: dateEvents,
        cushion: i < 0 || i > range,
      });
    }

    slots.reverse();

    this.setState({
      slots,
    });
  };

  componentWillUnmount() {
    if (this._unsubscribe) this._unsubscribe();
  }

  fetch = async () => {
    let { page } = this.state;
    this.setState({ fetching: true });
    let res = await chapterActions.timeline(page);
    console.log(res);
    if (res?.success) {
      this.setState({ fetching: false, chapters: res.chapters });
    } else {
      this.setState({ fetching: false });
      console.warn("Agenda fetch failed");
    }
  };

  render() {
    let { slots, events, chapters, values, fetching, momentLists } = this.state;

    return (
      <View style={this.styles().wrapper}>
        <FilterBar
          ref={(ref) => (this.filterBar = ref)}
          loading={fetching}
          onFetch={this.fetch}
          hideQuery={!ENV.WEB}
        />

        {!!events?.length && <TimelineGraph items={events} values={values} />}

        <FlatList
          style={this.styles().list}
          data={slots}
          renderItem={({ item: slot, index: i }) => {
            let events = slot.events;
            let chapter = chapters.find((ch) => ch.start_at == slot.date);
            return (
              <View style={this.styles().slotWrapper}>
                <Text small bold trim style={this.styles().slotHeader}>
                  {textHelpers
                    .formatDate(timeHelpers.dateToDateTime(slot.date))
                    .toUpperCase()}
                </Text>
                <View style={this.styles().slotContent}>
                  {!!chapter?.title?.length && (
                    <Text large>{chapter?.title}</Text>
                  )}
                  {!!chapter?.text?.length && (
                    <View style={[{ flex: 1, zIndex: 1 }]}>
                      <ScratchPad
                        inline
                        chapter={chapter}
                        // onUpdateChapter={async (chapter) => {
                        //   this.setState({ chapter, autoCreate: false });
                        //   this.props.addSubChapter && this.props.addSubChapter(chapter);
                        // }}
                        references={chapter.references}
                        // ref={(r) => (this.scratchPadRef = r)}
                        onUpdateText={(text) => {
                          this.setState({ chapter: { ...chapter, text } });
                        }}
                        onMetaCtrlRight={() =>
                          RootNavigation.push("Chapter", { id: chapter.id })
                        }
                        onMetaCtrlShiftRight={() =>
                          RootNavigation.push(
                            "Chapter",
                            { id: chapter.id },
                            { newTab: true }
                          )
                        }
                      />
                    </View>
                  )}
                  {!!chapter && (
                    <View style={{ marginVertical: this.context.sizes.base }}>
                      {momentLists.includes(chapter.id) ? (
                        <View>
                          <TouchableOpacity
                            onPress={() => {
                              this.toggleMomentList(chapter);
                            }}
                          >
                            <Ionicons
                              name="arrow-redo-sharp"
                              style={{
                                fontSize: this.context.sizes.smallItemHeight,
                                paddingRight: this.context.sizes.base,
                              }}
                              color={this.context.colors.trim}
                            />
                          </TouchableOpacity>
                          <MomentList
                            moments={chapter.moments}
                            chapter={chapter}
                          />
                        </View>
                      ) : (
                        <BadgeRow
                          index={0}
                          moments={chapter?.moments}
                          chapter={chapter}
                          rootChapter={chapter}
                          chapterMoments={chapter?.moments}
                          firstButton={() => {
                            return (
                              <TouchableOpacity
                                onPress={() => {
                                  this.toggleMomentList(chapter);
                                }}
                              >
                                <Ionicons
                                  name="arrow-redo-sharp"
                                  style={{
                                    fontSize:
                                      this.context.sizes.smallItemHeight,
                                    paddingRight: this.context.sizes.base,
                                    transform: [{ rotateX: "180deg" }],
                                  }}
                                  color={this.context.colors.trim}
                                />
                              </TouchableOpacity>
                            );
                          }}
                        />
                      )}
                    </View>
                  )}
                </View>
              </View>
            );
          }}
        />
      </View>
    );
  }

  toggleMomentList = (chapter) => {
    let { momentLists } = this.state;
    if (momentLists.includes(chapter.id)) {
      momentLists.splice(momentLists.indexOf(chapter.id), 1);
    } else {
      momentLists.push(chapter.id);
    }
    this.setState({ momentLists });
  };

  styles = () => ({
    wrapper: {
      flex: 1,
      justifyContent: "flex-start",
      maxHeight: this.context.sizes.HEIGHT - 66,
      maxHeight: this.context.sizes.HEIGHT - 78,
    },
    list: {
      flex: 1,
      // maxWidth: 400,
      // alignItems: "stretch",
    },
    slotWrapper: {
      width: Math.min(500, this.context.sizes.WIDTH),
      alignSelf: "center",
    },
    slotHeader: {
      padding: this.context.sizes.base,
      paddingVertical: this.context.sizes.small,
      // backgroundColor: this.context.colors.fill,
      borderColor: this.context.colors.trim,
      borderBottomWidth: 1,
    },
    slotContent: {
      minHeight: this.context.sizes.giant,
      padding: this.context.sizes.base,
      paddingBottom: this.context.sizes.large,
    },
  });
}
